export enum ShowDisclaimer {
    ONCE = 'once',
    ALWAYS = 'always',
}
